export default __webpack_public_path__ + "static/media/YAS0040.34I-27644_-16590_0.2d33b27a.jpg";